import { render, staticRenderFns } from "./CandidateSubmission.vue?vue&type=template&id=6cc047f9&scoped=true"
import script from "./CandidateSubmission.vue?vue&type=script&lang=js"
export * from "./CandidateSubmission.vue?vue&type=script&lang=js"
import style0 from "./CandidateSubmission.vue?vue&type=style&index=0&id=6cc047f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc047f9",
  null
  
)

export default component.exports